import { createSelector } from 'reselect'

const getLocalState = state => state.pages.story

export const getStoryId = createSelector(
	getLocalState,
	story => story.id
)
export const getStoryTitle = createSelector(
	getLocalState,
	story => story.title
)
export const getStoryImage = createSelector(
	getLocalState,
	story => story.image
)
export const getStoryContent = createSelector(
	getLocalState,
	story => story.content
)



// WEBPACK FOOTER //
// ./src/pages/story/storySelectors.js